import { render, staticRenderFns } from "./ExclusiveOffers.vue?vue&type=template&id=3c1cfaa6&scoped=true&"
import script from "./ExclusiveOffers.vue?vue&type=script&lang=js&"
export * from "./ExclusiveOffers.vue?vue&type=script&lang=js&"
import style0 from "./ExclusiveOffers.vue?vue&type=style&index=0&id=3c1cfaa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1cfaa6",
  null
  
)

export default component.exports